import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const recipe = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    initRecipe: {},
    defaultRecipe: {},
    savedRecipe: {},
    recipe_v2: {},
    recipeId: "",
    invalidUGCComponents: [],
  },
};

export default recipe;
